// Türkçe arayüz metinleri (varsayılan dil).
//
// Ton: resmî ve net; "siz" hitabı. Kısa cümleler, abartısız vaatler.
// Yalnızca pazarlama sloganları ("İzlemek istediğin. Olmak istediğin yerde.")
// marka sesi olarak samimi kalır; gövde metinleri ve işlevsel mesajlar resmîdir.
//
// Yer tutucular `{ad}` biçimindedir ve t() ile doldurulur.

export const tr = {
  // --- Sayfa üst bilgileri ---------------------------------------------------
  'meta.description': 'YouTube videoları, canlı TV kanalları ve kendi M3U/Xtream listeniz için tek oynatıcı. Kanal veya içerik paketi satılmaz. Hazır kanallarda süre sınırı yoktur; ücretsiz pakette YouTube günde 30 dakikadır.',
  'meta.home': 'YouTube, canlı TV ve IPTV listeniz tek oynatıcıda',
  'meta.notFound': 'Sayfa bulunamadı',
  'meta.compat': 'Cihazınız destekleniyor mu?',
  'meta.legal': 'Yasal bilgiler',
  'legal.privacy': 'Gizlilik Politikası',
  'legal.subscription': 'Abonelik ve İptal',
  'legal.contact': 'İletişim',

  // --- Dil -------------------------------------------------------------------
  'lang.label': 'Dil',
  'lang.lead': 'Arayüz dili bu cihazda saklanır ve diğer cihazlarınızı etkilemez.',
  'lang.tr': 'Türkçe',
  'lang.en': 'English',
  'lang.switch': 'Dil seçimi',

  // --- Ortak -----------------------------------------------------------------
  'common.back': 'Geri dönün',
  'common.retry': 'Tekrar deneyin',
  'common.cancel': 'Vazgeçin',
  'common.loading': 'Yükleniyor…',
  'common.loadMore': 'Daha fazla gösterin',
  'common.all': 'Tümü',
  'common.other': 'Diğer',
  // Hazır kanal kategorileri (config/channels.json Türkçe adlarla tutar).
  'cat.national': 'Ulusal',
  'cat.news': 'Haber',
  'cat.sports': 'Spor',
  'cat.documentary': 'Belgesel',
  'cat.music': 'Müzik',
  'cat.kids': 'Çocuk',
  'common.space': 'Boşluk',
  'common.error': 'Bir hata oluştu.',
  'common.network': 'Bağlantı kurulamadı. İnternet bağlantınızı kontrol edin.',
  'common.never': 'henüz yok',
  'common.justNow': 'az önce',
  'common.minutesAgo': '{n} dakika önce',
  'common.hoursAgo': '{n} saat önce',
  'common.daysAgo': '{n} gün önce',
  'common.viewPlans': 'Paketleri inceleyin',
  'common.goSettings': 'Ayarlara gidin',
  'common.goDiscover': 'Keşfet’e dönün',

  // --- Cihaz etiketleri (sunucuya kayıt adı olarak gider) --------------------
  'device.car': 'Araç ekranı',
  'device.tv': 'Televizyon',
  'device.tablet': 'Tablet',
  'device.phone': 'Telefon',
  'device.desktop': 'Bilgisayar',

  // --- Uygulama kabuğu -------------------------------------------------------
  'nav.discover': 'Keşfet',
  'nav.live': 'Canlı',
  'nav.mylist': 'Listem',
  'nav.iptv': 'IPTV',
  'nav.account': 'Ayarlar',
  'nav.plans': 'Paketler',
  'nav.settings': 'Ayarlar',
  'nav.logout': 'Çıkış yapın',
  'nav.search': 'Arama',
  'nav.searchPlaceholder': 'İçerik arayın',
  'nav.mainNav': 'Ana gezinme',
  'nav.sections': 'Bölümler',
  'nav.home': 'Ana ekran',
  'nav.accountMenu': 'Hesap menüsü',
  'nav.accountMenuTitle': 'Hesap, paketler ve ayarlar',
  'nav.myAccount': 'Hesabım',
  'nav.plusOnly': 'Plus paketine dâhildir',
  'nav.lockedLabel': '{label} — Plus paketine dâhildir',
  'nav.admin': 'İstatistikler',

  // --- İstatistik (yönetici) ---
  'admin.title': 'Kullanım istatistikleri',
  'admin.sub': 'Kim, hangi cihazdan, hangi kalitede, ne kadar izledi; uygulamadaki her hareket.',
  'admin.range.today': 'Bugün',
  'admin.range.7': '7 gün',
  'admin.range.30': '30 gün',
  'admin.range.90': '90 gün',
  'admin.range.365': '1 yıl',
  'admin.kpi.activeUsers': 'Etkin kullanıcı',
  'admin.kpi.totalUsers': 'Toplam hesap',
  'admin.kpi.newUsers': 'Yeni hesap',
  'admin.kpi.watchTime': 'İzleme süresi',
  'admin.kpi.sessions': 'Oynatma oturumu',
  'admin.kpi.avgSession': 'Ortalama oturum',
  'admin.kpi.bytes': 'Aktarılan veri',
  'admin.kpi.allTime': 'Toplam izleme (tüm zamanlar)',
  'admin.nowPlaying': 'Şu anda izleyenler',
  'admin.nowPlayingEmpty': 'Şu anda açık yayın yok.',
  'admin.byKind': 'İçerik türüne göre',
  'admin.byQuality': 'Kaliteye göre',
  'admin.byDevice': 'Cihaza göre',
  'admin.byPlan': 'Pakete göre',
  'admin.byDay': 'Günlere göre',
  'admin.byHour': 'Günün saatlerine göre (İstanbul)',
  'admin.topContent': 'En çok izlenenler',
  'admin.endReasons': 'Yayın bitiş nedenleri',
  'admin.eventCounts': 'Hareket sayıları',
  'admin.users': 'Kullanıcılar',
  'admin.users.search': 'E-posta veya ad arayın',
  'admin.users.total': '{n} hesap',
  'admin.events': 'Son hareketler',
  'admin.loadMore': 'Daha fazla gösterin',
  'admin.user.back': 'Tüm kullanıcılar',
  'admin.plan.title': 'Paket yönetimi',
  'admin.plan.listHint': 'Paketini değiştirmek için kullanıcının e-posta adresine dokunun.',
  'admin.plan.current': 'Mevcut paket: {plan}',
  'admin.plan.ends': 'Bitiş: {date}',
  'admin.plan.noExpiry': 'Bitiş tarihi yok',
  'admin.plan.hint': 'Seçilen paket hemen, tahsilatsız ve bitiş tarihi olmadan atanır. Plus’tan düşürme, açık IPTV yayınını kapatır.',
  'admin.plan.save': 'Paketi uygulayın',
  'admin.plan.saved': 'Paket {plan} olarak güncellendi.',
  'admin.event.admin_plan_changed': 'Yönetici paket değişikliği',
  'admin.user.sessions': 'Oynatma oturumları',
  'admin.user.events': 'Hareket dökümü',
  'admin.user.devices': 'Cihazlar',
  'admin.user.created': 'Kayıt tarihi',
  'admin.loadFail': 'İstatistikler yüklenemedi.',
  'admin.forbidden': 'Bu bölüm yalnızca yöneticilere açıktır.',
  'admin.empty': 'Bu aralıkta kayıt yok.',
  'admin.deleted': 'Silinmiş hesap',
  'admin.col.user': 'Kullanıcı',
  'admin.col.plan': 'Paket',
  'admin.col.watch': 'İzleme',
  'admin.col.sessions': 'Oturum',
  'admin.col.devices': 'Cihaz',
  'admin.col.lastSeen': 'Son görülme',
  'admin.col.created': 'Kayıt',
  'admin.col.day': 'Gün',
  'admin.col.users': 'Kullanıcı',
  'admin.col.title': 'Başlık',
  'admin.col.kind': 'Tür',
  'admin.col.time': 'Zaman',
  'admin.col.event': 'Hareket',
  'admin.col.detail': 'Ayrıntı',
  'admin.col.device': 'Cihaz',
  'admin.col.quality': 'Kalite',
  'admin.col.reason': 'Neden',
  'admin.col.count': 'Adet',
  'admin.col.stalls': 'Takılma',
  'admin.col.started': 'Başlangıç',
  'admin.unit.hours': '{h} sa {m} dk',
  'admin.unit.minutes': '{m} dk',
  'admin.unit.seconds': '{s} sn',
  'admin.quality.source': 'Kaynak kalitesi',
  'admin.kind.youtube-vod': 'YouTube video',
  'admin.kind.youtube-live': 'YouTube canlı',
  'admin.kind.youtube': 'YouTube',
  'admin.kind.tv': 'Hazır kanal',
  'admin.kind.iptv-live': 'IPTV canlı',
  'admin.kind.iptv-vod': 'IPTV film/dizi',
  'admin.kind.iptv': 'IPTV',
  'admin.kind.test': 'Test medyası',
  'admin.kind.unknown': 'Bilinmiyor',
  'admin.event.view': 'Sayfa görüntüleme',
  'admin.event.play_start': 'Oynatma başladı',
  'admin.event.play_end': 'Oynatma bitti',
  'admin.event.play_error': 'Oynatma hatası',
  'admin.event.player_error': 'Oynatıcı hatası',
  'admin.event.pause': 'Duraklatma',
  'admin.event.resume': 'Devam',
  'admin.event.stall': 'Takılma',
  'admin.event.net_slow': 'Donma teşhisi',
  'admin.net.client': 'İzleyicinin bağlantısı yavaş',
  'admin.net.source': 'Kaynak veya sunucu yavaş',
  'admin.net.gate': '{n} sn yükleme perdesi',
  'admin.net.backlog': '{n} KB yolda',
  'admin.net.clientCount': 'Bağlantı kaynaklı {n}',
  'admin.net.sourceCount': 'Kaynak kaynaklı {n}',
  'admin.event.seek': 'İleri/geri alma',
  'admin.event.skip': 'Atlama',
  'admin.event.quality_change': 'Kalite değişimi',
  'admin.event.fullscreen': 'Tam ekran',
  'admin.event.related_open': 'Benzer içerik rafı',
  'admin.event.takeover': 'Cihaz devri',
  'admin.event.search': 'Arama',
  'admin.event.favorite_add': 'Favoriye ekleme',
  'admin.event.favorite_remove': 'Favoriden çıkarma',
  'admin.event.source_add': 'Kaynak ekleme',
  'admin.event.source_remove': 'Kaynak silme',
  'admin.event.login': 'Giriş',
  'admin.event.register': 'Kayıt',
  'admin.event.logout': 'Çıkış',
  'admin.event.password_change': 'Parola değişikliği',
  'admin.event.password_reset_request': 'Parola sıfırlama talebi',
  'admin.event.password_reset': 'Parola sıfırlama',
  'admin.event.account_delete': 'Hesap silme',
  'admin.event.device_remove': 'Cihaz kaldırma',
  'admin.event.checkout_start': 'Ödeme başlatma',
  'admin.event.purchase': 'Satın alma',
  'admin.event.subscription_cancel': 'Abonelik iptali',
  'admin.event.subscription_resume': 'Abonelik devamı',
  'admin.billing.title': 'Abonelikler ve gelir',
  'admin.billing.testNote': 'Abonelik, alınamayan ödeme ve iptal sayıları deneme ortamındaki kayıtları da içerir; gelir tutarları içermez. Deneme ortamında: {n} abonelik, aylık karşılığı {mrr}, bu aralıkta tahsilat {collected}.',
  'admin.billing.paying': 'Ödeyen abonelik',
  'admin.billing.trial': 'Deneme süresinde',
  'admin.billing.unpaid': 'Ödemesi alınamayan',
  'admin.billing.cancelled': 'İptal edilmiş (erişimi süren)',
  'admin.billing.mrr': 'Aylık yinelenen gelir',
  'admin.billing.collected': 'Bu aralıkta tahsil edilen',
  'admin.billing.failed': 'Alınamayan ödeme',
  'admin.billing.cancellations': 'İptal',
  'admin.billing.payments': 'Son işlemler',
  'admin.billing.none': 'Bu aralıkta ödeme işlemi yok.',
  'admin.billing.deletedAccount': 'Silinmiş hesap',
  'admin.billing.col.period': 'Dönem',
  'admin.billing.col.subs': 'Abonelik',
  'admin.billing.col.test': 'Deneme ortamı',
  'admin.billing.col.kind': 'İşlem',
  'admin.billing.col.amount': 'Tutar',
  'admin.billing.kind.trial_started': 'Deneme başladı',
  'admin.billing.kind.purchase': 'Satın alma',
  'admin.billing.kind.renewal': 'Yenileme',
  'admin.billing.kind.payment_failed': 'Ödeme alınamadı',
  'admin.billing.kind.cancelled': 'İptal',
  'admin.billing.kind.plan_changed': 'Paket değişikliği',
  'admin.billing.kind.card_updated': 'Kart güncelleme',
  'admin.billing.kind.other': 'Diğer',
  'admin.event.plan_change': 'Paket değişikliği',
  'admin.event.card_update': 'Kart güncelleme',
  'admin.event.checkout_failed': 'Ödeme tamamlanamadı',
  'admin.event.purchase_failed': 'Yenileme ödemesi alınamadı',
  'admin.reason.client_stopped': 'Kullanıcı kapattı',
  'admin.reason.client_closed': 'Sekme kapandı',
  'admin.reason.source_ended': 'İçerik bitti',
  'admin.reason.quota_exhausted': 'Kota doldu',
  'admin.reason.taken_over': 'Başka cihaz devraldı',
  'admin.reason.preempted': 'Kapasite: ücretliye yer açıldı',
  'admin.reason.lease_expired': 'Bağlantı koptu',
  'admin.reason.entitlement_lost': 'Paket hakkı düştü',
  'admin.reason.start_failed': 'Başlatılamadı',
  'admin.reason.server_shutdown': 'Sunucu yeniden başladı',
  'admin.reason.source_deleted': 'Kaynak silindi',
  'admin.reason.account_deleted': 'Hesap silindi',
  'admin.reason.stopped': 'Durduruldu',
  'quota.exhausted': 'YouTube süreniz doldu',
  'quota.secondsLeft': 'YouTube: {n} sn kaldı',
  'quota.minutesLeft': 'YouTube: {n} dk kaldı',
  'quota.title': 'Ücretsiz pakette YouTube videoları için her gün toplam {n} dakika oynatma hakkı bulunur. Hazır kanallar bu süreden düşmez.',

  // --- Tanıtım sayfası -------------------------------------------------------
  'landing.nav.experience': 'Deneyim',
  'landing.nav.plans': 'Paketler',
  'landing.nav.login': 'Giriş yapın',
  'landing.cta.startFree': 'Ücretsiz başlayın',
  'landing.hero.title1': 'İzlemek istediğin.',
  'landing.hero.title2': 'Olmak istediğin yerde.',
  'landing.hero.lead': 'YouTube videoları, canlı TV kanalları ve kendi IPTV listeniz tek oynatıcıda. Araç ekranında, telefonda, bilgisayarda.',
  'landing.hero.noteFree': 'Kanallar süresiz, YouTube günde 30 dakika. Kart istenmez.',
  'landing.showcase.sample': 'Örnek görünüm',
  'landing.scene.alt': 'Kıyı yolu ve yelkenli — özgün örnek illüstrasyon',
  'landing.scene.tag': 'Biraz uzaklaşın.',
  'landing.scene.title1': 'Kıyının',
  'landing.scene.title2': 'öte yanında.',
  'landing.scene.body1': 'Yeni bir manzara, başka bir hikâye.',
  'landing.scene.body2': 'Kendinize ayırdığınız zamana eşlik etsin.',
  'landing.scene.cta': 'Arayüzü inceleyin',
  'landing.shelf.1': 'Yükseklerde bir gün',
  'landing.shelf.2': 'Şehrin başka bir yüzü',
  'landing.shelf.3': 'Günün son ışığı',
  'landing.shelf.meta': 'Örnek içerik · {n} dk kaldı',
  'landing.caption.1': 'Tek ekran. Sade bir izleme deneyimi.',
  'landing.caption.2': 'Tasarım gösterimi; içerikler örnektir.',
  'landing.device.phone': 'Telefon',
  'landing.device.tablet': 'Tablet',
  'landing.device.pc': 'Bilgisayar',
  'landing.device.tv': 'TV tarayıcısı',
  'landing.device.compat': 'Uyumluluk durumu',
  'landing.feature.title1': 'Kendi listeniz.',
  'landing.feature.title2': 'Kendi düzeniniz.',
  'landing.feature.body': 'Plus paketiyle IPTV kaynağınızı ekleyin. Kanallarınızı, filmlerinizi ve dizilerinizi tek yerde bulun; favorilerinize dönün, kaldığınız yerden devam edin.',
  'landing.feature.link': 'Plus paketini inceleyin',
  'landing.source.head': 'Kaynaklarım',
  'landing.source.title': 'Her şey yerli yerinde.',
  'landing.source.body': 'İçerikler, eklediğiniz sağlayıcıdan gelir.',
  'landing.source.row1': 'Canlı kanallar',
  'landing.source.row1meta': 'Kategorilere göre',
  'landing.source.row2': 'Filmler ve diziler',
  'landing.source.row2meta': 'Tek listede',
  'landing.source.row3': 'Favorileriniz',
  'landing.source.row3meta': 'Kolay erişim',
  'landing.pillars.title1': 'Üç kaynak.',
  'landing.pillars.title2': 'Tek oynatıcı.',
  'landing.pillar.1.title': 'YouTube’da arayın ve keşfedin',
  'landing.pillar.1.body': 'Aradığınız videoyu bulun, konulara göre keşfedin ve kaldığınız yerden devam edin.',
  'landing.pillar.2.title': 'Hazır canlı kanallar',
  'landing.pillar.2.body': 'Ulusal, haber, müzik ve belgesel kanalları tek dokunuşla açılır; liste eklemeniz gerekmez ve süre sınırı yoktur.',
  'landing.pillar.3.title': 'Kendi IPTV listeniz',
  'landing.pillar.3.body': 'Plus paketiyle M3U veya Xtream kaynağınızı ekleyin; kanallarınız, filmleriniz ve dizileriniz aynı yerde.',
  'landing.car.tag': 'Araç ekranı',
  'landing.car.title1': 'Aracınızın ekranında,',
  'landing.car.title2': 'uygulama kurmadan.',
  'landing.car.body': 'Tesla ve benzeri araç tarayıcıları için tasarlandı: uygulama kurulmaz, adresi açarak kullanılır. Arayüz, kol mesafesinden okunacak ve araç içinde rahat dokunulacak biçimde boyutlandırılmıştır.',
  'landing.car.point1': 'Büyük dokunma hedefleri ve okunaklı yazı',
  'landing.car.point2': 'Alçak ve geniş ekranlara sığan oynatıcı',
  'landing.car.point3': 'Park hâlinde, aracın izin verdiği ölçüde tam ekran',
  'landing.car.safety': 'Sürüş sırasında video izlemeyin. Ekran yolcular içindir.',
  'landing.car.devices': 'Aynı hesap şu ekranlarda da açılır:',
  'landing.closing.title': 'Bugün ücretsiz deneyin.',
  'landing.closing.body': 'Hesap açmak ücretsizdir ve kart bilgisi istenmez. Hazır kanalları süre sınırı olmadan, YouTube videolarını her gün 30 dakika izleyebilirsiniz.',
  'landing.faq.q5': 'Yıllık ödemede ne kazanırım?',
  'landing.faq.a5': 'Yıllık ödemede 12 aylık kullanım için 10 aylık ücret alınır; iki ay ücretsizdir. Deneme süresi aylık ve yıllık ödemede aynıdır.',
  'landing.faq.q6': 'Araç ekranında nasıl kullanırım?',
  'landing.faq.a6': 'Araç tarayıcısında adresi açıp hesabınıza giriş yapın; uygulama kurulmaz. Tesla tarayıcısında tam ekran yalnızca araç park hâlindeyken, Tiyatro kipinde açılabilir; oynatıcıdaki tam ekran düğmesi bunun için gereken adımı gösterir. Araç modeline ve yazılım sürümüne göre davranış değişebilir.',
  'landing.faq.title1': 'Sıkça sorulan',
  'landing.faq.title2': 'sorular.',
  'landing.faq.q1': 'Ücretsiz pakete neler dâhildir?',
  'landing.faq.a1': 'Hazır canlı kanalları süre sınırı olmadan izleyebilirsiniz. YouTube videoları için her gün toplam 30 dakika hakkınız bulunur. Kişisel IPTV ücretsiz pakete dâhil değildir.',
  'landing.faq.q2': 'Plus paketi hazır bir IPTV aboneliği içeriyor mu?',
  'landing.faq.a2': 'Hayır. Plus, kendi M3U veya Xtream kaynağınızı ekleyebileceğiniz oynatıcı özelliklerini açar. Kanal veya içerik paketi satılmaz.',
  'landing.faq.q3': 'Birden fazla cihazda izleyebilir miyim?',
  'landing.faq.a3': 'Hesabınızı farklı cihazlarda kullanabilirsiniz. Aynı anda yalnızca tek yayın açılır; bu sınır tüm paketlerde aynıdır.',
  'landing.faq.q4': 'Hangi cihazlar destekleniyor?',
  'landing.faq.a4': 'Araç, telefon, tablet, bilgisayar ve TV tarayıcıları hedeflenmektedir. Gerçek model ve tarayıcı uyumluluğu ayrıca doğrulanmaktadır; bu sürüm uyumluluk garantisi vermez.',
  'landing.footer.tagline': 'İzlemeye biraz yer açın.',
  'landing.plans.loadFail': 'Paket bilgisi şu anda yüklenemedi. Sayfayı yenileyip tekrar deneyin.',

  // --- Paketler --------------------------------------------------------------
  'plans.intro.title1': 'Size uygun',
  'plans.intro.title2': 'paketle başlayın.',
  'plans.intro.body1': 'Her pakette aynı anda tek yayın.',
  'plans.intro.body2': 'Kişisel IPTV erişimi yalnızca Plus paketinde.',
  'plans.fine.vat': 'Fiyatlara KDV dâhildir.',
  'plans.fine.limits': 'Paketlerde sınırsız kullanım taahhüdü verilmez; adil kullanım ilkesi uygulanır ve olası sınırlar önceden bu sayfada duyurulur.',
  'plans.fine.noIptv': 'IPTV aboneliği veya içerik paketi satılmaz; kendi kaynağınızı eklemeniz gerekir.',
  'plans.fine.mock': 'Ödeme sağlayıcısı henüz bağlı değildir: satın alma adımı test akışıdır, gerçek tahsilat yapılmaz.',
  'plans.fine.real': 'Ödemeler iyzico altyapısıyla alınır; kart bilgileriniz bu sitede saklanmaz. Ödeme adımında tutar ve yenileme dönemi yeniden gösterilir.',
  'plans.fine.sandbox': 'TEST ortamı: ödemeler iyzico’nun deneme sisteminde yapılır, gerçek tahsilat yapılmaz.',
  'plans.fine.offline': 'Çevrim içi ödeme şu anda kullanıma açık değildir; paket geçişleri {contact} bölümündeki adres üzerinden yapılır.',
  'plans.contactToUpgrade': 'Paket geçişi için {contact} bölümündeki adrese yazın.',
  'plans.swipe': 'Paketleri görmek için yana kaydırın',
  'plans.free': '0 TL',
  'plans.perFirstMonth': ' TL / ilk ay',
  'plans.perMonth': ' TL / ay',
  'plans.perYear': ' TL / yıl',
  'plans.period.label': 'Ödeme dönemi',
  'plans.period.monthly': 'Aylık',
  'plans.period.yearly': 'Yıllık',
  'plans.period.badge': '2 ay ücretsiz',
  'plans.renew.yearly': 'Aylık karşılığı {price}.',
  'plans.renew.yearlyNote': '{n} ay ücretsiz; yılda {saving} tasarruf.',
  'plans.createAccount': 'Hesap oluşturun',
  'plans.checkout.yearly': 'Yıllık {price} · 365 günde bir yenilenir',
  'pay.periodValueYearly': '365 gün',
  'plans.renew.free': 'YouTube için her gün 30 dakika',
  'plans.renew.intro': 'Sonraki aylar {price}.',
  'plans.renew.introNote': 'Yeni üyelere özel.',
  'plans.renew.flat': 'İlk aydan itibaren aynı fiyat.',
  'plans.renew.flatNote': 'Dilediğiniz zaman iptal edebilirsiniz.',
  'plans.renew.trial': 'İlk {n} gün ücretsiz.',
  'plans.renew.trialNote': 'Sonra {price}; denemede iptal ücretsiz.',
  'plans.renew.yearlyTrial': 'İlk {n} gün ücretsiz · aylık karşılığı {price}.',
  'plans.current': 'Mevcut paketiniz',
  'plans.backToFree': 'Ücretsiz pakete dönmek için aboneliğinizi iptal edin.',
  'plans.cancelFirst': 'Paket değiştirmek için önce mevcut aboneliğinizi iptal edin. Yeni paket satın aldığınız gün başlar; mevcut dönemin kalan süresi yeni pakete aktarılmaz.',
  'plans.changeTo': '{name} paketine geçin',
  'plans.changeTitle': '{name} paketine geçiş',
  'plans.changeTrial': '{name} paketine şimdi geçersiniz. Deneme süreniz korunur ve deneme bitiminde kartınızdan {price} alınır. Kesin tarih, değişiklikten sonra Aboneliğiniz bölümünde gösterilir.',
  'plans.changeUp': '{name} paketi hemen açılır ve bu dönem için sizden ek ücret alınmaz. {date} tarihinden itibaren {price} alınır.',
  'plans.changeDown': '{date} tarihine kadar mevcut paketinizi kullanmaya devam edersiniz. O tarihten itibaren {name} paketine geçilir ve {price} alınır.',
  'plans.changeConfirm': 'Paketi değiştirin',
  'plans.changedNow': '{name} paketine geçtiniz.',
  'plans.changedLater': 'Paket değişikliğiniz kaydedildi; {date} tarihinde uygulanacak.',
  'plans.changePending': 'Sonraki dönemde {name} paketine geçeceksiniz. Yeni bir değişiklik o tarihten sonra yapılabilir.',
  'plans.changePendingThis': '{date} tarihinden itibaren bu pakete geçeceksiniz.',
  'plans.periodChange': 'Ödeme dönemini (aylık ya da yıllık) değiştirmek için önce mevcut aboneliğinizi iptal edin. Yeni abonelik satın aldığınız gün başlar; mevcut dönemin kalan süresi eklenmez.',
  'plans.resubscribe': 'Yeniden abone olun',
  'plans.unpaidFirst': 'Son ödemeniz alınamadı. Aşağıdan kartınızı güncelleyebilir ya da aboneliğinizi iptal edebilirsiniz.',
  'plans.switchTitle': 'Yeni abonelik bugün başlar',
  'plans.switchBody': 'Mevcut paketinizi {date} tarihine kadar kullanma hakkınız var. Şimdi yeni bir abonelik başlatırsanız ücret bugün alınır ve dönem bugünden sayılır; mevcut dönemin kalan süresi eklenmez.',
  'plans.switchConfirm': 'Devam edin',
  'plans.continueFree': 'Ücretsiz devam edin',
  'plans.startFree': 'Ücretsiz başlayın',
  'plans.buyOnPhone': 'Telefonunuzdan satın alın',
  'plans.choose': '{name} paketini seçin',
  'plans.checkout.title': '{name} paketi',
  'plans.checkout.monthly': 'Aylık {price} · her 30 günde bir yenilenir',
  'plans.checkout.first': 'İlk ödeme {first} · sonraki yenileme {renew}',
  'plans.checkout.test': 'Ödeme sağlayıcısı bağlı değildir. Kart bilgisi istenmez, tahsilat yapılmaz.',
  'plans.checkout.confirmTest': 'Test ödemesine geçin',
  'plans.checkout.confirm': 'Ödemeye geçin',
  'plans.checkout.fail': 'Satın alma başlatılamadı.',
  'plans.page.title': 'Paketler',
  'plans.page.sub': 'Her pakette aynı anda tek yayın.',
  'plans.page.loadFail': 'Paketler yüklenemedi',
  'plans.name.free': 'Ücretsiz',
  'plans.name.starter': 'Başlangıç',
  'plans.name.plus': 'Plus',

  // --- Abonelik --------------------------------------------------------------
  'sub.section': 'Aboneliğiniz',
  'sub.active': 'Etkin paket',
  'sub.expiredSuffix': ' · süresi doldu',
  'sub.renewal': 'Yenileme',
  'sub.noRenewal': 'Yenileme yok',
  'sub.concurrent': 'Eşzamanlı yayın',
  'sub.concurrentValue': '{n} — tüm paketlerde aynı',
  'sub.iptv': 'Kişisel IPTV',
  'sub.on': 'Açık',
  'sub.off': 'Kapalı · Plus paketi gerekir',
  'sub.endingTitle': 'Abonelik dönem sonunda sona erecek',
  'sub.endingBody': 'Dönem sonunda Ücretsiz pakete dönersiniz.',
  'sub.endingNoResume': 'Abonelik iptal edildi; dönem sonuna kadar kullanmaya devam edersiniz. Yeniden abone olmak için bir paket seçebilirsiniz.',
  'sub.resume': 'İptali geri alın',
  'sub.title': 'Abonelik',
  'sub.cancelBody': 'İptal ettiğinizde dönem sonuna kadar tüm özellikleri kullanmaya devam edersiniz.',
  'sub.cancel': 'Aboneliği iptal edin',
  'sub.cancelDialogTitle': 'Abonelik iptali',
  'sub.cancelDialogBody': 'Dönem sonunda Ücretsiz pakete dönersiniz. O tarihe kadar tüm özellikler kullanılabilir kalır.',
  'sub.cancelConfirm': 'İptal edin',
  'sub.keep': 'Aboneliği sürdürün',
  'sub.cancelled': 'Abonelik dönem sonunda sona erecektir.',
  'sub.cancelledNow': 'Abonelik iptal edildi; hesabınız Ücretsiz pakete döndü.',
  'sub.cancelDialogBodyNow': 'Ödeme döneminiz dolmuş olduğu için iptal ettiğinizde erişiminiz hemen sona erer ve hesabınız Ücretsiz pakete döner.',
  'sub.resumed': 'İptal geri alındı.',
  'sub.pendingPlan': 'Sonraki dönem',
  'sub.pendingPlanValue': '{plan} · {date} tarihinden itibaren',
  'sub.cardTitle': 'Ödeme kartı',
  'sub.cardBody': 'Kartınız ödeme sağlayıcısı iyzico’da saklanır; bu sitede kart bilgisi tutulmaz ve gösterilemez. Kartınızı iyzico’nun formundan değiştirebilirsiniz.',
  'sub.cardUpdate': 'Kartı güncelleyin',
  'sub.cardDone': 'Kart güncelleme formu tamamlandı. Kartınız kabul edildiyse sonraki tahsilatta kullanılır.',
  'sub.cardUnknown': 'Kart güncelleme adımından dönüldü, ancak sonucu doğrulanamadı. Kartınız değişmemiş olabilir; emin olmak için yeniden deneyebilirsiniz.',
  'sub.cardFailed': 'Kart güncellenemedi. Yeniden deneyebilirsiniz.',
  'sub.ev.plan_changed': '{plan} · paket değişikliği',
  'sub.ev.card_updated': 'Ödeme kartı güncelleme formu tamamlandı',
  'sub.trialTag': 'Deneme süresi',
  'sub.period': 'Ödeme dönemi',
  'sub.trialEnds': 'Deneme bitişi ve ilk tahsilat',
  'sub.nextCharge': 'Sonraki tahsilat',
  'sub.chargeValue': '{date} · {price}',
  'sub.accessEnds': 'Erişim bitişi',
  'sub.accessEndsValue': '{date} · yeni tahsilat yapılmaz',
  'sub.planEnds': 'Paket bitişi',
  'sub.noEnd': 'Süresiz',
  'sub.endedTitle': 'Aboneliğiniz sona erdi',
  'sub.endedBody': 'Ücretsiz paketi kullanıyorsunuz. Yukarıdan bir paket seçerek yeniden abone olabilirsiniz.',
  'sub.unpaidTitle': 'Son ödemeniz alınamadı',
  'sub.unpaidBody': 'Yenileme ücreti kartınızdan alınamadı. Ödeme sağlayıcısı tahsilatı yeniden deneyebilir; gerçekleşirse aboneliğiniz kesintisiz sürer. Gerçekleşmezse erişiminiz {date} tarihinde sona erer. Kartınızı aşağıdan güncelleyebilirsiniz.',
  'sub.unpaidEndedBody': 'Yenileme ücreti alınamadığı için paketiniz kapandı. Yeniden abone olmak için önce bu aboneliği iptal edin, ardından bir paket seçin.',
  'sub.history': 'İşlem geçmişi',
  'sub.historyLead': 'Satın almalarınız, tahsilatlar ve abonelik değişiklikleri. Bu kayıtlar fatura yerine geçmez.',
  'sub.historyEmpty': 'Henüz bir işleminiz yok.',
  'sub.historyFail': 'İşlem geçmişi yüklenemedi.',
  'sub.historyRef': 'İşlem no {ref}',
  'sub.noCharge': 'Ücret alınmadı',
  'sub.ev.trial_started': '{plan} · deneme süresi başladı',
  'sub.ev.purchase': '{plan} · satın alma',
  'sub.ev.renewal': '{plan} · yenileme',
  'sub.ev.payment_failed': '{plan} · ödeme alınamadı',
  'sub.ev.cancelled': '{plan} · abonelik iptal edildi',
  'sub.ev.resumed': '{plan} · iptal geri alındı',
  'sub.ev.admin': '{plan} · paket tanımlandı',
  'sub.ev.other': '{plan} · işlem',
  'addons.title': 'Ekler',
  'addons.body': 'Ekler bağlı oldukları paketle birlikte çalışır; taban paket sona erdiğinde ek de sona erer.',
  'addons.requires': '{plan} paketi gerektirir',

  // --- Test ödemesi ----------------------------------------------------------
  'pay.title': 'Ödeme',
  'pay.plan': '{name} paketi',
  'pay.testNote': ' Ödeme sağlayıcısı henüz bağlı değildir. Bu ekran gerçek bir ödeme sayfası değildir: kart bilgisi istenmez, tahsilat yapılmaz, hiçbir sağlayıcıya istek gönderilmez.',
  'pay.package': 'Paket',
  'pay.period': 'Dönem',
  'pay.periodValue': '30 gün',
  'pay.charge': 'Tahsilat',
  'pay.chargeValue': 'Yok — test kaydıdır, gerçek abonelik değildir',
  'pay.record': 'İşlem kaydı',
  'pay.recordValue': 'Test olarak işaretlenir',
  'pay.activate': 'Test aboneliğini etkinleştirin',
  'pay.processing': 'İşleniyor…',
  'bill.title': 'Fatura bilgileri',
  'bill.lead': 'Abonelik, ödeme altyapısı iyzico üzerinden açılır ve iyzico bu bilgileri zorunlu tutar. Bilgileriniz yalnızca iyzico’ya iletilir; bu sitede saklanmaz.',
  'bill.name': 'Ad',
  'bill.surname': 'Soyad',
  'bill.identity': 'T.C. kimlik numarası',
  'bill.phone': 'Cep telefonu',
  'bill.phonePh': '05xx xxx xx xx',
  'bill.city': 'İl',
  'bill.address': 'Fatura adresi',
  'bill.submit': 'Ödemeye geçin',
  'bill.opening': 'Ödeme sayfası açılıyor…',
  'bill.invalid': 'Bilgileri eksiksiz ve doğru girin: kimlik numarası 11 hane, telefon alan koduyla.',
  'bill.cardNote': 'Kart bilgilerinizi bir sonraki adımda iyzico’nun formuna girersiniz.',
  'bill.formTitle': 'Fatura sahibi',
  'bill.identityHint': 'iyzico, aboneliği kişiye açtığı için ister.',
  'bill.stepsLabel': 'Ödeme adımları',
  'bill.step1': 'Fatura bilgileri',
  'bill.step2': 'Kart bilgileri',
  'bill.step3': 'Onay',
  'bill.summaryTitle': 'Sipariş özeti',
  'bill.sumPlan': 'Paket',
  'bill.sumPeriod': 'Ödeme dönemi',
  'bill.monthly': 'Aylık',
  'bill.yearly': 'Yıllık',
  'bill.sumAfterTrial': '{n} gün sonra',
  'bill.sumToday': 'Bugün ödenecek',
  'bill.dueTrial': 'Ücret alınmaz',
  'bill.assureCard': 'Kart bilgileriniz iyzico’nun formuna girilir; bu siteye ulaşmaz ve burada saklanmaz.',
  'bill.assureProvider': 'Ödeme altyapısı: iyzico.',
  'bill.assureCancel': 'Aboneliğinizi Paketler ekranından dilediğiniz zaman iptal edebilirsiniz.',
  'bill.assureCreditCard': 'Abonelik ödemeleri yalnızca kredi kartıyla alınır; banka kartı kabul edilmez.',
  'bill.consentLink': 'Abonelik ve iptal koşullarını',
  'bill.consent': 'okudum. Hizmetin hemen başlamasını istiyorum; bu nedenle cayma hakkımın bulunmadığını ve tahsil edilen ücretlerin iade edilmediğini kabul ediyorum.',
  'bill.consentRequired': 'Devam etmek için abonelik koşullarını onaylayın.',
  'bill.assureNoRefund': 'İptal ettiğinizde dönem sonuna kadar kullanmaya devam edersiniz; kullanılmayan süre için ücret iadesi yapılmaz.',
  'pay.success': 'Aboneliğiniz başladı.',
  'pay.failed': 'Ödeme tamamlanamadı; abonelik başlatılmadı.',
  'pay.expired': 'Ödeme oturumunun süresi doldu. Yeniden deneyin.',
  'pay.verifying': 'Ödemeniz doğrulanıyor…',
  'pay.pending': 'Ödemeniz henüz doğrulanamadı. Paketiniz birkaç dakika içinde açılmazsa bu ekranı yeniden açın; sorun sürerse İletişim adresinden bize yazın.',
  'done.title': 'Aboneliğiniz başladı',
  'done.leadTrial': '{plan} paketiniz deneme süresiyle açıldı. Bugün sizden ücret alınmadı.',
  'done.leadPaid': '{plan} paketiniz açıldı ve ödemeniz alındı.',
  'done.paidToday': 'Bugün ödenen',
  'done.mail': 'Bu bilgiler {email} adresine e-postayla da gönderilir.',
  'done.cancelNote': 'Aboneliğinizi Paketler ekranından dilediğiniz zaman iptal edebilirsiniz; iptal ettiğinizde dönem sonuna kadar kullanmaya devam edersiniz.',
  'done.watch': 'İzlemeye başlayın',
  'done.manage': 'Aboneliği yönetin',
  'done.noneTitle': 'Tamamlanmış bir satın alma bulunamadı',
  'done.noneBody': 'Etkin bir aboneliğiniz görünmüyor. Paketler ekranından bir paket seçebilirsiniz.',
  'done.toPlans': 'Paketlere gidin',
  'done.refLabel': 'İşlem no',

  // --- Ayarlar ---------------------------------------------------------------
  'settings.title': 'Ayarlar',
  'settings.password.current': 'Mevcut parolanız',
  'settings.password.new': 'Yeni parola',
  'settings.password.newPlaceholder': 'En az 8 karakter',
  'settings.password.note': 'Parolanızı değiştirdiğinizde diğer cihazlardaki oturumlar kapatılır; bu cihaz açık kalır.',
  'settings.password.title': 'Parola değişikliği',
  'settings.password.confirm': 'Değiştirin',
  'settings.password.fail': 'Parola değiştirilemedi.',
  'settings.delete.placeholder': 'Parolanız',
  'settings.delete.body1': 'Hesabınız, kaynaklarınız, favorileriniz, izleme geçmişiniz ve cihaz kayıtlarınız silinir. Bu işlem geri alınamaz.',
  'settings.delete.body2': 'Günlük yedeklerdeki kopyalar en geç 14 gün içinde silinir.',
  'settings.delete.label': 'Onaylamak için parolanızı girin',
  'settings.delete.title': 'Hesabı kalıcı olarak silin',
  'settings.delete.confirm': 'Hesabı silin',
  'settings.delete.fail': 'Hesap silinemedi.',
  'settings.logout': 'Çıkış yapın',
  'settings.deleteBtn': 'Hesabı silin',
  'settings.passBtn': 'Parolayı değiştirin',
  'settings.subscription': 'Abonelik',
  'settings.subLead': 'Paket değişikliği ve iptal işlemleri Paketler ekranından yapılır.',
  'settings.package': 'Paket',
  'settings.dailyTime': 'Günlük YouTube süresi',
  'settings.dailyValue': '{n} dakika · gece yarısı sıfırlanır ({tz})',
  'settings.dailyNone': 'Günlük süre sınırı uygulanmaz',
  'settings.plansRow': 'Paketler',
  'settings.plansRowMeta': 'Paketleri, aboneliğinizi ve işlem geçmişinizi görün.',
  'settings.plansRowBtn': 'Paketlere gidin',
  'settings.security': 'Güvenlik',
  'settings.securityLead': 'Parolanızı değiştirdiğinizde diğer cihazlardaki oturumlar kapatılır. Parolanızı unuttuysanız giriş ekranındaki “Parolanızı mı unuttunuz?” bağlantısıyla e-posta üzerinden sıfırlayabilirsiniz.',
  'settings.legalLead': 'Kullanım koşulları, gizlilik ve abonelik metinleri herkese açık sayfada yer alır.',
  'settings.deleteSection': 'Hesap silme',
  'settings.deleteLead': 'Hesabınız ve tüm verileriniz kalıcı olarak silinir: kaynaklarınız, favorileriniz, izleme geçmişiniz ve cihaz kayıtlarınız. Bu işlem geri alınamaz.',

  // --- Kaynaklar -------------------------------------------------------------
  'sources.title': 'Kaynaklarım',
  'sources.loadFail': 'Kaynaklar yüklenemedi',
  'sources.lockedLead': 'Kendi M3U veya Xtream listenizi eklemek Plus paketinde mümkündür. Ücretsiz ve Başlangıç paketlerinde IPTV bulunmaz.',
  'sources.lockedTitle': 'Plus ile kendi kaynağınızı bağlayın',
  'sources.lockedBody': 'Kaynağınızı ekledikten sonra kanallarınız, filmleriniz ve dizileriniz IPTV bölümünde toplanır.',
  'sources.count.live': 'kanal',
  'sources.count.movie': 'film',
  'sources.count.series': 'dizi',
  'sources.count.episode': 'bölüm',
  'sources.sync': 'Yenileyin',
  'sources.synced': 'Liste güncellendi.',
  'sources.syncFail': 'Yenileme başarısız: {error} Önceki listeniz korundu.',
  'sources.delete': 'Silin',
  'sources.deleteTitle': 'Kaynağı silin',
  'sources.deleteBody': '“{name}” ve bu kaynaktan gelen katalog silinecektir. Bu kaynağa ait favorileriniz de kaldırılır.',
  'sources.deleted': 'Kaynak silindi.',
  'sources.updated': '{time} güncellendi',
  'sources.lastFail': 'Son yenileme başarısız: {error}',
  'sources.notSynced': 'Henüz yenilenmedi',
  'sources.goChannels': 'Kanallara gidin',
  'sources.slotsFull': 'Kaynak alanlarınız dolu. Yeni kaynak eklemek için mevcut kaynaklardan birini silin.',
  'sources.addOnPhone': 'Telefonunuzdan ekleyin',
  'sources.anyway': 'Yine de burada girin',
  'sources.phoneTitle': 'Kaynağınızı telefonunuzdan ekleyin',
  'sources.phoneBody': 'M3U adresi veya Xtream kullanıcı adı ve parolası uzundur; araç ekranında yazmak zordur. Telefonunuzdan eklediğinizde kanallarınız burada görünür.',
  'sources.addNew': 'Yeni kaynak ekleyin',
  'sources.lead': 'Paketinizde {n} kaynak alanı bulunur. İçerikler eklediğiniz sağlayıcıdan gelir; kanal veya içerik paketi satılmaz.',
  'sources.emptyTitle': 'İzlemeye başlamak için listenizi ekleyin',
  'sources.emptyBody': 'M3U adresi veya Xtream sunucu bilgilerinizle kendi kaynağınızı bağlayın.',
  'sources.form.xtream': 'Xtream — sunucu, kullanıcı adı, parola',
  'sources.form.m3u': 'M3U — liste bağlantısı',
  'sources.form.namePlaceholder': 'Ev listem',
  'sources.form.m3uLabel': 'M3U adresi',
  'sources.form.m3uHint': 'Listenin doğrudan bağlantısı. http veya https ile başlamalıdır.',
  'sources.form.epgLabel': 'Yayın rehberi adresi',
  'sources.form.epgHint': 'İsteğe bağlıdır. Kaynak destekliyorsa şimdi/sonra bilgisi buradan alınır.',
  'sources.form.hostLabel': 'Sunucu adresi',
  'sources.form.hostHint': 'Yalnızca adres ve port; kullanıcı adını buraya yazmayın.',
  'sources.form.userLabel': 'Kullanıcı adı',
  'sources.form.userPlaceholder': 'kullanıcı adı',
  'sources.form.passLabel': 'Parola',
  'sources.form.passHint': 'Parolanız şifreli saklanır ve kayıtlara yazılmaz.',
  'sources.form.test': 'Bağlantıyı deneyin',
  'sources.form.save': 'Kaydedin ve içerikleri alın',
  'sources.form.testing': 'Deneniyor…',
  'sources.form.saving': 'Kaydediliyor ve içerikler alınıyor. Büyük listelerde bu işlem biraz sürebilir.',
  'sources.form.added': 'Kaynak eklendi. Kanallarınız IPTV bölümünde.',
  'sources.form.title': 'Yeni kaynak',
  'sources.form.lead': 'Bilgileri sağlayıcınız verir. Önce bağlantıyı deneyip ardından kaydedebilirsiniz.',
  'sources.form.typeLabel': 'Tür',
  'sources.form.nameLabel': 'Ad',

  // --- Cihazlar --------------------------------------------------------------
  'devices.title': 'Cihazlar',
  'devices.lead': 'İstediğiniz kadar cihazda giriş yapabilirsiniz; aynı anda yalnızca birinde yayın açılır.',
  'devices.none': 'Kayıtlı cihaz yok',
  'devices.thisDevice': 'bu cihaz',
  'devices.lastSeen': 'Son görülme {time} · {n} açık oturum',
  'devices.signOutHere': 'Bu cihazdan çıkın',
  'devices.remove': 'Cihazı kaldırın',
  'devices.removed': 'Cihaz oturumu kapatıldı.',

  // --- Destek ----------------------------------------------------------------
  'support.title': 'Destek bilgileri',
  'support.lead': 'Bir sorun bildirirken bu bilgileri paylaşın.',
  'support.build': 'Uygulama derlemesi',
  'support.webcodecs': 'WebCodecs',
  'support.supported': 'Destekleniyor',
  'support.unsupported': 'Desteklenmiyor — bu tarayıcıda oynatma çalışmaz',
  'support.deviceLabel': 'Cihaz etiketi',
  'support.browser': 'Tarayıcı',
  'support.clip': 'Tanı klibini oynatın',
  'support.clipTitle': 'Tanı klibi',
  'support.clipRow': 'Oynatma tanı klibi ',
  'support.clipMeta': 'Görüntüdeki saniye sayacı ile sesteki bip aynı anda olmalıdır.',

  // --- Uyumluluk -------------------------------------------------------------
  'compat.title': 'Cihazınız destekleniyor mu?',
  'compat.ok': 'Bu tarayıcı oynatma için gereken desteğe sahiptir.',
  'compat.bad': 'Bu tarayıcıda oynatma çalışmaz. Güncel Chrome, Edge veya Safari kullanabilirsiniz.',
  'compat.lead': 'Uygulama tarayıcıda çalışır; kurulum gerekmez. Arayüz aşağıdaki cihazların ekranına göre düzenlenir.',
  'compat.pc': 'Güncel Chrome, Edge veya Safari · klavye ve fare',
  'compat.phone': 'Dikey ekrana uyarlanmış düzen · dokunmatik kullanım',
  'compat.car': 'Büyük düğmeli araç düzeni · uzun metin girişi telefona devredilir',
  'compat.tablet': 'Geniş ekran düzeni · dokunmatik kullanım',
  'compat.tv': 'Uzaktan okunabilir büyük yazı ve düzen',
  'compat.foot': 'Oynatma için tarayıcının güncel bir sürüm olması gerekir. Desteklemeyen bir tarayıcıda uygulama bunu açıkça bildirir; boş ekran göstermez.',

  // --- Giriş / kayıt ---------------------------------------------------------
  'auth.titleLogin': 'Tekrar hoş geldiniz.',
  'auth.titleRegister': 'Hesabınızı oluşturun.',
  'auth.leadLogin': 'Listeleriniz ve kaldığınız yerler tüm cihazlarınızda sizinle.',
  'auth.leadRegister': 'Hesap açmak ücretsizdir. Hazır kanalları süre sınırı olmadan, YouTube videolarını her gün 30 dakika izleyebilirsiniz.',
  'auth.name': 'Ad (isteğe bağlı)',
  'auth.namePlaceholder': 'Adınız',
  'auth.email': 'E-posta',
  'auth.emailPlaceholder': 'ornek@eposta.com',
  'auth.password': 'Parola',
  'auth.passwordPlaceholder': 'Parolanız',
  'auth.passwordNew': 'En az 8 karakter',
  'auth.consent.terms': 'Kullanım Koşulları',
  'auth.consent.kvkk': 'KVKK Aydınlatma Metni',
  'auth.consent.and': '’nı kabul ediyorum; ',
  'auth.consent.tail': '’ni okudum. 18 yaşımı doldurdum.',
  'auth.login': 'Giriş yapın',
  'auth.register': 'Hesap oluşturun',
  'auth.switchToRegister': 'Hesap oluşturun',
  'auth.switchToLogin': 'Giriş yapın',
  'auth.noAccount': 'Hesabınız yok mu? ',
  'auth.haveAccount': 'Zaten hesabınız var mı? ',
  'auth.consentRequired': 'Devam etmek için koşulları ve aydınlatma metnini onaylamanız gerekir.',
  'auth.fail': 'İşlem tamamlanamadı.',
  'auth.forgot': 'Parolanızı unuttuysanız {contact} bölümündeki adrese yazın.',
  'auth.forgotLink': 'Parolanızı mı unuttunuz?',
  'auth.reset.titleForgot': 'Parolanızı sıfırlayın',
  'auth.reset.leadForgot': 'Hesabınızın e-posta adresini girin; yeni parola belirlemeniz için size bir bağlantı gönderilir.',
  'auth.reset.send': 'Bağlantı gönderin',
  'auth.reset.remembered': 'Parolanızı hatırladınız mı? ',
  'auth.reset.validFor': 'Bağlantı {n} dakika geçerlidir. İleti birkaç dakika içinde ulaşmazsa istenmeyen posta klasörünüzü kontrol edin.',
  'auth.reset.titleNew': 'Yeni parola belirleyin',
  'auth.reset.leadNew': 'Yeni parolanızı girin. Kaydettiğinizde bütün cihazlardaki oturumlarınız kapatılır.',
  'auth.reset.newPassword': 'Yeni parola',
  'auth.reset.save': 'Parolayı kaydedin',
  'auth.reset.missing': 'Bu bağlantı geçersiz. Yeni bir sıfırlama bağlantısı isteyin.',
  'auth.reset.requestNew': 'Yeni bağlantı isteyin',
  'auth.visualTitle': 'İzlemek istediğin yerde.',
  'auth.visualNote': 'Örnek illüstrasyon; gerçek katalog görseli değildir.',
  'auth.car.drive': 'Sürüş sırasında video izlemeyin. Bu ekran yolcular içindir.',

  // --- Telefona devir --------------------------------------------------------
  'handoff.plan.title': 'Paketi telefonunuzdan satın alın',
  'handoff.plan.lead': 'Ödeme adımı araç ekranına uygun değildir. Telefonunuzdan bu adrese gidin, aynı hesapla giriş yapın ve paketi orada seçin. Araç ekranı kendiliğinden güncellenir.',
  'handoff.plan.step3': 'Paketi seçin ve ödemeyi tamamlayın.',
  'handoff.plan.step3plus': 'Plus paketini seçin ve ödemeyi tamamlayın.',
  'handoff.plan.fallback': 'Yine de burada devam edin',
  'handoff.source.title': 'Kaynağınızı telefonunuzdan ekleyin',
  'handoff.source.lead': 'M3U adresi veya Xtream kullanıcı adı ve parolası uzundur; araç ekranında yazmak zordur. Telefonunuzdan ekleyin, kanallarınız burada görünsün.',
  'handoff.source.step3': 'Ayarlar → Kaynaklarım → Yeni kaynak ekleyin.',
  'handoff.source.fallback': 'Yine de burada girin',
  'handoff.step1': 'Telefonunuzda tarayıcıyı açın ve yukarıdaki adresi yazın.',
  'handoff.step2': 'Aynı e-posta ile giriş yapın.',
  'handoff.url': 'Telefonunuzdan bu adrese gidin',
  'handoff.back': 'Geri dönün',

  // --- Keşfet / arama / canlı / IPTV / listem --------------------------------
  'locked.alt': 'Örnek arayüz görseli',
  'locked.tag': 'Plus paketinde',
  'locked.title1': 'Kendi listeniz.',
  'locked.title2': 'Kendi düzeniniz.',
  'locked.body': '{what} kendi M3U veya Xtream kaynağınızdan gelir. Kanal veya içerik paketi satılmaz.',
  'locked.stateTitle': 'Plus ile kendi kaynağınızı ekleyin',
  'locked.stateBody': 'Kanallarınızı, filmlerinizi ve dizilerinizi tek yerde toplayın; favorilerinize dönün, kaldığınız yerden devam edin. Ücretsiz ve Başlangıç paketlerinde IPTV bulunmaz.',
  'discover.title': 'Bugün ne izlemek istersiniz?',
  'discover.subtitle': 'Bir şey keşfedin, canlı yayına geçin veya kaldığınız yerden devam edin.',
  'discover.loading': 'İzlenecekler hazırlanıyor…',
  'discover.continue': 'Kaldığınız yerden',
  'discover.goList': 'Listem’e gidin',
  'discover.shelf': 'Keşfedin',
  'discover.emptyTitle': 'Keşfet şu anda boş',
  'discover.emptyBody': 'İçerik sağlayıcısına ulaşılamadı. Arama yine de çalışıyor olabilir.',
  'discover.loadFail': 'Keşfet yüklenemedi',
  'discover.moreFail': 'Devamı yüklenemedi.',
  'discover.mixed': 'Karışık',
  'discover.liveNow': 'Şu anda canlı',
  'discover.watch': 'İzleyin',
  'discover.liveStrip': 'Canlı kanallar',
  'discover.allChannels': 'Tüm kanallar',
  'search.placeholder': 'Video, kanal veya film adı',
  'search.title': 'Arama',
  'search.recent': 'Son aramalarınız',
  'search.clear': 'Temizleyin',
  'search.emptyTitle': 'Ne aramak istersiniz?',
  'search.emptyBody': 'Yukarıdaki alana bir video, kanal veya film adı yazın.',
  'search.searching': 'Aranıyor…',
  'search.videos': 'Videolar',
  'search.mylist': 'IPTV listem',
  'search.countMine': '{n} sonuç · IPTV listem',
  'search.noMatchTitle': 'IPTV listenizde eşleşme yok',
  'search.noMatchBody': 'Farklı bir ad deneyebilir veya kaynağınızı Ayarlar bölümünden yenileyebilirsiniz.',
  'search.count': '{n} sonuç',
  'search.noResultTitle': 'Sonuç bulunamadı',
  'search.noResultBody': 'Yazımı kontrol edin veya daha kısa bir ifade deneyin.',
  'search.loadMoreN': 'Daha fazla gösterin ({n})',
  'search.end': 'Liste sonu.',
  'search.fail': 'Sonuçlar yüklenemedi',
  'live.title': 'Canlı',
  'live.subIptv': 'Hazır kanallar ve kendi listeniz',
  'live.subFree': 'Hazır kanallar. Kendi listeniz Plus paketiyle açılır.',
  'live.channelSearch': 'Kanal arayın',
  'live.builtin': 'Hazır kanallar',
  'live.noMatch': 'Eşleşen kanal yok',
  'live.noMatchBody': 'Aramayı temizleyip tekrar deneyin.',
  'live.listFail': 'Kanal listesi yüklenemedi',
  'live.listFailBody': 'Bağlantınızı kontrol edip tekrar deneyin.',
  'live.mine': 'IPTV listem',
  'live.mineLockedTitle': 'Kendi kanallarınız Plus paketinde',
  'live.mineLockedBody': 'M3U veya Xtream kaynağınızı ekleyerek kendi kanallarınızı buraya getirin.',
  'live.seePlus': 'Plus’ı inceleyin',
  'live.goIptv': 'IPTV bölümüne geçin',
  'iptv.title': 'IPTV',
  'iptv.lockedWhat': 'IPTV kanalları, filmleri ve dizileri',
  'iptv.tabChannels': 'Kanallar',
  'iptv.tabMovies': 'Filmler',
  'iptv.tabSeries': 'Diziler',
  'iptv.sync': 'Yenileyin',
  'iptv.addFirst': 'Önce Ayarlar bölümünden bir kaynak ekleyin.',
  'iptv.noChannelTitle': 'Bu listede kanal yok',
  'iptv.noChannelBody': 'Kaynağınızı yenilemeyi veya başka bir kategori seçmeyi deneyin.',
  'iptv.showing': '{shown} / {total} kanal gösteriliyor. Daraltmak için kategori seçin.',
  'iptv.channelsFail': 'Kanallar yüklenemedi',
  'iptv.noMovies': 'Bu listede film yok',
  'iptv.noSeries': 'Bu listede dizi yok',
  'iptv.noKindBody': 'Kaynağınız bu türde içerik sunmuyor olabilir. Ayarlar bölümünden listeyi yenilemeyi deneyin.',
  'iptv.contentFail': 'İçerik yüklenemedi',
  'series.title': 'Dizi',
  'series.lockedWhat': 'Diziler',
  'series.noEpisodesSeason': 'Bu sezonda bölüm yok',
  'series.season': '{n}. sezon',
  'series.playFirst': 'İlk bölümü oynatın',
  'series.back': 'Dizilere dönün',
  'series.tag': 'Dizi',
  'series.noEpisodesTitle': 'Bölüm listesi yok',
  'series.noEpisodesBody': 'Sağlayıcı bu dizi için bölüm bilgisi vermemiştir.',
  'series.fail': 'Dizi açılamadı',
  'library.title': 'Listem',
  'library.tabContinue': 'Kaldığınız yerden',
  'library.tabFavorites': 'Favoriler',
  'library.noFavTitle': 'Favoriniz yok',
  'library.noFavBody': 'Kartların üzerindeki yıldıza dokunarak kanal, video veya film ekleyin.',
  'library.noContinueTitle': 'Yarım kalan içerik yok',
  'library.noContinueBody': 'Bir video veya film izlemeye başladığınızda buradan devam edebilirsiniz.',
  'library.fail': 'Listem yüklenemedi',

  // --- Kartlar ---------------------------------------------------------------
  'cards.noImage': 'Görsel yok',
  'cards.addFav': 'Listem’e ekleyin',
  'cards.removeFav': 'Listem’den çıkarın',
  'cards.favFail': 'Listem’e kaydedilemedi.',
  'cards.live': 'CANLI',
  'cards.noEpg': 'Program bilgisi yok',
  'cards.next': 'Sonra: {title}',
  'cards.left': '{time} kaldı',
  'cards.watched': 'İzlendi',
  'cards.kind.youtubeVod': 'Video',
  'cards.kind.youtubeLive': 'Canlı yayın',
  'cards.kind.tv': 'Canlı kanal',
  'cards.kind.iptvLive': 'IPTV · kanal',
  'cards.kind.iptvMovie': 'Film',
  'cards.kind.iptvEpisode': 'Dizi bölümü',
  'cards.kind.iptvSeries': 'Dizi',
  'cards.kind.test': 'Tanı klibi',
  'cards.kind.content': 'İçerik',
  'cards.episodeSub': '{season}. sezon {episode}. bölüm',

  // --- Geri bildirim bileşenleri ---------------------------------------------
  'feedback.confirm': 'Devam edin',
  'feedback.cancel': 'Vazgeçin',
  'notFound.title': 'Sayfa bulunamadı',
  'notFound.body': 'Aradığınız ekran taşınmış olabilir.',

  // --- Oynatıcı --------------------------------------------------------------
  'player.noWebCodecs': 'Bu tarayıcı video oynatmayı desteklemiyor. Güncel Chrome, Edge veya Safari ile deneyin.',
  'player.connecting': 'Bağlanıyor…',
  'player.preparing': 'Yayın hazırlanıyor…',
  'player.openFail': 'Bu yayın şu anda açılamıyor. Lütfen tekrar deneyin.',
  'player.activeTitle': 'Başka bir cihazda yayın açık',
  'player.activeBody': 'Hesabınızda aynı anda tek yayın olabilir. Şu anda “{title}” {device} üzerinde oynatılıyor. Diğer cihazı durdurup burada izlemek ister misiniz?',
  'player.activeDefaultTitle': 'bir içerik',
  'player.activeDefaultDevice': 'başka bir cihaz',
  'player.activeConfirm': 'Burada izleyin',
  'player.busy': 'Sunucu şu anda yoğun. Birkaç dakika sonra tekrar deneyin.',
  'player.preemptedTitle': 'Sunucu şu anda yoğun',
  'player.preemptedBody': 'Kapasite dolduğu için bu yayın kapatıldı. Biraz sonra yeniden açabilirsiniz.',
  'player.takenTitle': 'Yayın başka bir cihaza geçti',
  'player.takenBody': 'Bu yayın, hesabınızdaki başka bir cihazda izlemeye başlandığı için durduruldu.',
  'player.entitlementLost': 'Paket hakkınız sona erdiği için IPTV yayını kapatıldı.',
  'player.stoppedTitle': 'Yayın durduruldu',
  'player.stoppedBody': 'Yayın sunucu tarafında sona erdi. Geri dönüp yeniden açabilirsiniz.',
  'player.seekFail': 'Konum değiştirilemedi. Tekrar deneyin.',
  'player.seeking': 'Konum ayarlanıyor…',
  'player.cantOpen': 'Bu yayın açılamıyor',
  'player.quotaTitle': 'Bugünkü ücretsiz YouTube süreniz doldu',
  'player.quotaBody': 'Ücretsiz pakette YouTube videoları için her gün toplam 30 dakika oynatma hakkı bulunur. Kaldığınız yer kaydedildi; ücretli pakete geçtiğinizde buradan devam edebilirsiniz. Hazır kanallar süre sınırı olmadan açıktır.',
  'player.plusTitle': 'Bu içerik Plus paketinde',
  'player.goPlus': 'Plus’a geçin',
  'player.drive': 'Sürüş sırasında video izlemeyin. Bu ekran yolcular içindir; hareket hâlindeki araçta ekrana bakmak tehlikelidir ve yasak olabilir.',
  'player.quotaSoon': 'Bugünkü ücretsiz YouTube süreniz bir dakika içinde dolacak. Kaldığınız yer kaydedilecektir.',
  'player.decodeErr': 'Bu yayın bu cihazda oynatılamıyor. Başka bir yayın deneyin.',
  'player.parseErr': 'Bu yayın bu cihazda oynatılamıyor. Başka bir yayın deneyin.',
  'player.noTrack': 'Bu yayında görüntü bulunamadı.',
  'player.unsupported': 'Bu yayın bu cihazda oynatılamıyor. Başka bir yayın deneyin.',
  'player.streamFail': 'Video akışı açılamadı.',
  'player.ctl.back': 'Geri',
  'player.ctl.close': 'Kapat (Esc)',
  'player.ctl.play': 'Oynat',
  'player.ctl.pause': 'Duraklat',
  'player.ctl.playTitle': 'Oynat / duraklat (boşluk)',
  'player.ctl.back10': '10 saniye geri',
  'player.ctl.back10Title': '10 saniye geri (sol ok)',
  'player.ctl.fwd10': '10 saniye ileri',
  'player.ctl.fwd10Title': '10 saniye ileri (sağ ok)',
  'player.ctl.channels': 'Kanal listesi',
  'player.ctl.quality': 'Görüntü kalitesi',
  'player.ctl.qualityLabel': 'Kalite {q}p',
  'player.ctl.fullscreen': 'Tam ekran',
  'player.ctl.fullscreenTitle': 'Tam ekran (F)',
  'player.ctl.mute': 'Sesi kapat',
  'player.ctl.unmute': 'Sesi aç',
  'player.ctl.volume': 'Ses seviyesi',
  'player.ctl.position': 'Konum',
  'player.live': 'CANLI',
  'player.skipSec': '{n} sn',
  'player.rotate': 'Daha büyük izlemek için telefonu yatay çevirin',
  'player.fullscreenUnsupported': 'Bu tarayıcı tam ekrana izin vermiyor.',
  'player.teslaFullTitle': 'Tam ekran için Tiyatro kipi gerekir',
  'player.teslaFullBody': 'Tesla tarayıcısı sayfaların tam ekrana geçmesine yalnızca Tiyatro kipinde izin verir. Devam ettiğinizde sayfa YouTube yönlendirmesi üzerinden tam ekran olarak yeniden açılır; açılan sayfada siteye gitmeyi onaylamanız gerekir. Aracınız park hâlinde olmalıdır. Kaldığınız yer kaydedilir.',
  'player.teslaFullConfirm': 'Tam ekran açın',
  'player.netSlow': 'İnternet bağlantınız yavaş veya dalgalı görünüyor. Görüntüde donma yaşanabilir.',
  'player.netSlowQuality': 'İnternet bağlantınız yavaş veya dalgalı görünüyor. Görüntüde donma yaşanabilir; daha düşük bir kalite seçebilirsiniz.',
  'playback.related': 'Bunları da izleyin',
  'playback.relatedSub': 'Aynı kanaldan benzer içerikler',
  'playback.backToList': 'Listeye dönün',
  'playback.noRelated': 'Öneri bulunamadı.',
  'playback.relatedFail': 'Öneriler yüklenemedi.',
  'player.reconnecting': 'Yeniden bağlanılıyor…',
  'player.lostTitle': 'Bağlantı kesildi',
  'player.lostBody': 'Yayına ulaşılamıyor. İnternet bağlantınızı kontrol edip tekrar deneyin.',
  'boot.offlineTitle': 'Sunucuya ulaşılamıyor',
  'boot.offlineBody': 'İnternet bağlantınızı kontrol edin. Bağlantı geri geldiğinde sayfa kendiliğinden açılır; isterseniz şimdi tekrar deneyin.',
};
